<template>
    <div class="container">
        <named-value
            class="named-value"
            :name="texts.delivery_form"
            variant="left"
        >
            {{ texts["delivery_" + deliveryMethod] }}
        </named-value>

        <named-value class="named-value" :name="texts.name" variant="left">
            {{ name }}
        </named-value>

        <named-value class="named-value" :name="texts.email" variant="left">
            {{ email }}
        </named-value>

        <named-value
            v-if="deliveryMethod === 'email'"
            class="named-value"
            :name="texts.chosen_id"
            variant="left"
        >
            {{ texts.identificationTypeText }}
        </named-value>

        <named-value
            v-if="deliveryMethod === 'email'"
            class="named-value"
            :name="controlNumbersHeader"
            variant="left"
        >
            {{ controlNumbers }}
        </named-value>

        <named-value
            v-if="deliveryMethod === 'snailmail'"
            class="named-value"
            :name="texts.delivery_address"
            variant="left"
        >
            <div>{{ deliveryName }}</div>
            <div>{{ deliveryAddress }}</div>
            <div>{{ deliveryZip }} {{ deliveryCity }}</div>
        </named-value>

        <p class="description">
            {{ texts["description_" + deliveryMethod] }}
        </p>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NamedValue from "@/components/elements/NamedValue";

export default {
    components: {
        NamedValue
    },
    computed: {
        texts() {
            const identificationTypeText = this.identificationType
                ? this.identificationType.texts[this.$i18n.locale]
                : "";
            return {
                ...this.$t("block_delivery_information"),
                identificationTypeText
            };
        },
        controlNumbersHeader() {
            if (
                this.identificationType &&
                this.identificationType.useDigitsFromEnd
            ) {
                // Info: https://kazupon.github.io/vue-i18n/guide/pluralization.html#custom-pluralization
                return this.$t(
                    "block_delivery_information.control_numbers",
                    1,
                    {
                        count: this.identificationType.numberOfControlDigits
                    }
                );
            } else if (this.identificationType) {
                return this.$t(
                    "block_delivery_information.control_numbers_first",
                    1,
                    { count: this.identificationType.numberOfControlDigits }
                );
            } else {
                // Default text untill an id is chosen
                return this.$t(
                    "block_delivery_information.control_numbers",
                    1,
                    {
                        count: 4
                    }
                ); // default
            }
        },
        ...mapGetters({
            name: "customer/getName",
            email: "customer/getEmail",
            identificationType: "customer/getIdentificationType",
            controlNumbers: "customer/getControlNumbers",
            deliveryName: "customer/getDeliveryName",
            deliveryAddress: "customer/getDeliveryAddress",
            deliveryZip: "customer/getDeliveryZip",
            deliveryCity: "customer/getDeliveryCity",
            deliveryMethod: "order/getDeliveryMethod"
        })
    }
};
</script>

<style scoped lang="scss">
$element-BlockDeliveryInformation-background: transparent !default;
$element-BlockDeliveryInformation-color: $body-color !default;
$element-BlockDeliveryInformation-padding: 0 !default;

.container {
    background: $element-BlockDeliveryInformation-background;
    padding: $element-BlockDeliveryInformation-padding;
    color: $element-BlockDeliveryInformation-color;
}

.named-value {
    margin-bottom: 0.5rem;
}

.named-value ::v-deep .name {
    flex: 0 0 140px;
}

.description {
    margin-top: 2rem;
    margin-bottom: 2rem;
}
</style>
